import Vue from 'vue';
import store from 'store';

import skyOverlayStore from './store';
import SkyOverlay from './sky-overlay';
import skyOverlayToggle from './sky-overlay-toggle';
import pageWrap from './page-wrap';

// Register skyOverlayStore as module in global store
store.registerModule('skyOverlay', skyOverlayStore);

// Main component
Vue.component('sky-overlay', SkyOverlay);

// Sub components
Vue.component('page-wrap', pageWrap);
Vue.component('sky-overlay-toggle', skyOverlayToggle);

export default SkyOverlay;



// WEBPACK FOOTER //
// ./scripts/sky-overlay/index.js